var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:`${!_vm.$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`,attrs:{"id":"app","dark":_vm.$vuetify.theme.dark}},[_c('router-view'),_c('Snackbar'),_c('Progressbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }